import axios from 'axios';

const baseUrl = process.env.REACT_APP_QCX_API_BASE_URL! + '/' + process.env.REACT_APP_RELATORIOS_API_PROCESSOS_ABERTOS!; 

const generateSpreadsheet = async (
  dataInicio: string,
  dataFim: string,
  token: string,
  unidadeId: number,
  unidadesNegocioIDs: number[],
  status: string,
  produto: string,
  reportType: string = 'ABERTOS'
) => {
  const params = new URLSearchParams();
  params.set('tenentId', unidadesNegocioIDs.join(','));
  params.set('dataInicial', dataInicio);
  params.set('dataFim', dataFim);
  params.set('status', status);
  params.set('produto', produto);
  params.set('tipoRelatorio', reportType); 

  let message = null;

  console.log(baseUrl);

  try {
    const response = await axios.get(`${baseUrl}?${params.toString()}`, {
      headers: {
        Authorization: `Bearer ${token}`,
        'Content-Type': 'multipart/form-data',
        quickcomexTenant: unidadeId,
      },
      responseType: 'blob',
    });

    if (response.status === 200) {
      let filenome = '';
      if(reportType === 'ABERTOS') {
        filenome = 'relatorioProcessosAbertos.xlsx';
      } else if(reportType === 'REGISTRADOS') {
        filenome = 'controleProcessosRegistrados.xlsx';
      }
      const file = new File([response.data], filenome, {
        type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
      });
      

      const url = window.URL.createObjectURL(file);
      const a = document.createElement('a');
      a.href = url;
      a.download = file.name;
      a.click();
    } else {
      message = await response.data.text();
    }
  } catch (error) {
    if (axios.isAxiosError(error)) {
      if (error.response && error.response.data) {
        message = await error.response.data.text();
      } else {
        message = 'Erro inesperado';
      }
    } else {
      message = 'Erro inesperado';
    }
  }
  return message;
};

export { generateSpreadsheet };
